import { useLocation } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';
import { SidebarTrigger } from '@/components/ui/sidebar';
import ThemeModeSwitcher from './Header/HeaderContent/ThemeModeSwitcher';
import { navigation } from '@/menu';

function usePageTitle(): string {
  const { pathname } = useLocation();

  for (const item of navigation) {
    if (item.href === pathname) return item.name;
    if (item.children) {
      for (const child of item.children) {
        if (child.href === pathname) return child.name;
      }
    }
  }

  if (pathname === '/dashboard') return 'Dashboard';
  return 'Dashboard';
}

export function SiteHeader() {
  const title = usePageTitle();

  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 h-4 data-vertical:self-auto"
        />
        <h1 className="text-base font-medium">{title}</h1>
        <div className="flex-1" />
        <ThemeModeSwitcher />
      </div>
    </header>
  );
}
